import { render, staticRenderFns } from "./AlumnoCrearAsesoria.vue?vue&type=template&id=64d0bfa8&"
import script from "./AlumnoCrearAsesoria.vue?vue&type=script&lang=js&"
export * from "./AlumnoCrearAsesoria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports